if (!customElements.get('article-slider')) {
  class ArticleSlider extends HTMLElement {
    constructor() {
      super();
      this.options = {
        type: 'loop',
        waitForTransition: false,
        perPage: 1,
        pagination: true,
        height: '48rem',
        breakpoints: {
          989: {
            perPage: 1,
            arrows: true,
            pagination: true,
          },
        },
      };
    }

    connectedCallback() {
      const element = this.querySelector('.js-slider');
      if (!element || !Splide) return;
      this.slider = new Splide(element, this.options).mount();
    }
  }
  customElements.define('article-slider', ArticleSlider);
}
